"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePaymentSalesforceSchema = void 0;
exports.CreatePaymentSalesforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        payment: {
            properties: {
                externalId: {
                    type: 'string',
                },
                date: {
                    type: 'string',
                },
                amount: {
                    type: 'number',
                },
                status: {
                    type: 'string',
                },
                type: {
                    type: 'string',
                },
                processingMode: {
                    type: 'string',
                },
                cancellationDate: {
                    type: 'string',
                },
                effectiveDate: {
                    type: 'string',
                },
                paymentServiceProviderId: {
                    type: 'string',
                },
                lifecycle: {
                    type: 'string',
                },
            },
            required: ['externalId', 'date', 'amount', 'status', 'type', 'processingMode'],
            type: 'object',
        },
        paymentMethod: {
            properties: {
                externalId: {
                    type: 'string',
                },
                paymentMethodType: {
                    type: 'string',
                },
            },
            type: 'object',
        },
        subscription: {
            properties: {
                externalId: {
                    type: 'string',
                },
            },
            required: ['externalId'],
            type: 'object',
        },
    },
    required: ['payment', 'paymentMethod', 'subscription'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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